<template>
  <a-form-item name="node_to_back" label="Selecciona el nodo a volver" required>
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :value="value"
      @update:value="handleChange"
      placeholder="Seleccionar nodo"
    >
      <a-select-option v-for="node in nodes" :key="node.id">
        {{ NodeTypeName[node.type] }} ({{ AcronymByNode[node.type] }}{{ node.id }})
      </a-select-option>
    </a-select>

    <p>Se volverá a enviar el mensaje u opciones del nodo seleccionado.</p>
  </a-form-item>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import { Node } from "@/@types/chatbots";
import { fetchParentNodes } from "@/app/chatbots/services/chatbotNodes/fetchParentNodes";
import { AcronymByNode, NodeTypeName } from "@/app/chatbots/utils/texts";

const props = defineProps<{ value: number | undefined; nodeId: number }>();

const emit = defineEmits<{ "update:value": [value: number] }>();

const nodes = ref<Node[]>([]);

onMounted(async () => {
  nodes.value = await fetchParentNodes(props.nodeId);
});

const handleChange = (value: number) => {
  emit("update:value", value);
};
</script>

<style scoped lang="sass">
p
  margin: 0
  color: $gray-7
</style>
